// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15-Hv","rootNoMargin":"styles_rootNoMargin__1aEi3"};